import { useState } from "react";
import AccordionContact from "./index";
import { AccordionData } from "./data";
import * as StyledAccordion from "./Styled.Accordion";

const AccordionContactData = () => {
  const [expanded, setExpanded] = useState(0);

  return (
    <StyledAccordion.ContactFaqWrapper>
      <StyledAccordion.ContactFaqInner>
        {AccordionData.map((e, i) => (
          <AccordionContact
            key={i}
            id={i}
            title={e.title}
            content={e.content}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </StyledAccordion.ContactFaqInner>
    </StyledAccordion.ContactFaqWrapper>
  );
};

export default AccordionContactData;
